

export class RouteGroupWithStatusOutputData implements IRouteGroupWithStatusOutputData {
    /** The auto-generated id of the route group master */
    route_group_id!: number;
    /** The route group name with 500 character limit */
    route_group_name!: string;
    /** The company name with 500 character limit */
    company_name!: string;
    /** The total number of allocated path */
    total_allocated_path!: number;
    /** The total number of effected vehicle */
    total_effected_vehicle!: number;
    /** Manage status of alert group. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IRouteGroupWithStatusOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route_group_id = _data["route_group_id"];
            this.route_group_name = _data["route_group_name"];
            this.company_name = _data["company_name"];
            this.total_allocated_path = _data["total_allocated_path"];
            this.total_effected_vehicle = _data["total_effected_vehicle"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RouteGroupWithStatusOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new RouteGroupWithStatusOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route_group_id"] = this.route_group_id;
        data["route_group_name"] = this.route_group_name;
        data["company_name"] = this.company_name;
        data["total_allocated_path"] = this.total_allocated_path;
        data["total_effected_vehicle"] = this.total_effected_vehicle;
        data["status"] = this.status;
        return data; 
    }
}

export interface IRouteGroupWithStatusOutputData {
    /** The auto-generated id of the route group master */
    route_group_id: number;
    /** The route group name with 500 character limit */
    route_group_name: string;
    /** The company name with 500 character limit */
    company_name: string;
    /** The total number of allocated path */
    total_allocated_path: number;
    /** The total number of effected vehicle */
    total_effected_vehicle: number;
    /** Manage status of alert group. 0 For De-active, 1 For Active */
    status: number;
}

